import { dangerouslyLoadTrustedFormScript } from '@clearlink/emily'
import { graphql, useStaticQuery } from 'gatsby'
import React, { useEffect, useState } from 'react'

import { Form } from '@leshen/ui'
import { useMapi } from '../../../context/MapiProvider'
import emilySubmit, { emilyTCPAUpdate } from '../utils'

const SylexFormWithMapi = (props) => {
  const { fields, submissionUrl } = props || {}
  const data = useStaticQuery(graphql`
    query SylexFormAddressQualQuery {
      site {
        siteMetadata {
          smartyStreetsWebsiteKey
          addressQualificationCode
        }
      }
    }
  `)

  const { smartyStreetsWebsiteKey, addressQualificationCode } =
    data.site.siteMetadata

  const mapiData = useMapi()
  const submissionData = { ...mapiData }
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    dangerouslyLoadTrustedFormScript()
    setIsLoading(false)
  }, [])

  if (isLoading) {
    return null
  }

  return (
    <Form
      onSubmit={emilySubmit}
      emilyTCPAUpdate={emilyTCPAUpdate}
      submissionData={submissionData}
      smartyStreetsWebsiteKey={smartyStreetsWebsiteKey}
      addressQualificationCode={addressQualificationCode}
      fields={fields}
      disclaimer={props?.disclaimer}
      submissionUrl={submissionUrl}
      {...props}
    />
  )
}

export default SylexFormWithMapi
